export default "__VITE_ASSET__D1yI$wBR__"